import React, { useEffect, useState } from "react";
import { useLoaderData } from "react-router";

import Select from "react-select";

import BonusTable from "./components/BonusTable";
import { LeagueYears } from "./types/bonus";

import { store } from "../../../../..";
import { globalActions } from "../../../../../features/global/globalSlice";
import { IUmpireUser } from "../../../../../types/api";
import { getUmpires, getYears } from "../../../../../lib/api";
import { Col, Row } from "react-bootstrap";
import { AsyncStatuses } from "../../../../../types/shared";
import Loading from "../../../../../components/Loading";
import classNames from "classnames";
import DownloadButton from "./components/DownloadButton";

export const loader = async () => {
    const { settings, sites } = store.getState().global;
    const promises = [];
    !sites.length && promises.push(store.dispatch(globalActions.getSites()));
    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));

    const [{ years }] = await Promise.all([getYears(), ...promises]);

    return {
        years,
    };
};

const Bonus = (): React.ReactNode => {
    const { years } = useLoaderData() as LeagueYears;
    const [umpires, setUmpires] = useState<IUmpireUser[]>([]);
    const [year, setYear] = useState<number | undefined>(undefined);
    const [loadingStatus, setLoadingStatus] =
        useState<AsyncStatuses>(undefined);

    useEffect(() => {
        const updateUmpires = async () => {
            setLoadingStatus("pending");
            await getUmpires(year)
                .then(response => {
                    const newUmpires = response.umpires.sort((a, b) =>
                        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
                    );
                    setUmpires(newUmpires);
                    setLoadingStatus("success");
                })
                .catch(e => {
                    setLoadingStatus("failed");
                });
        };

        year && updateUmpires();
    }, [year, setLoadingStatus, setUmpires]);

    return (
        <>
            <Row>
                <Col>
                    {loadingStatus === "pending" && (
                        <Loading className={classNames("adminArchive")} />
                    )}
                </Col>
            </Row>
            <Row>
                <Col xs={2}>
                    <h5>Select Year:</h5>
                    <Select
                        isMulti={false}
                        isClearable={false}
                        isSearchable={false}
                        options={Array.from(Object.keys(years)).map(y => ({
                            value: parseInt(y),
                            label: parseInt(y),
                        }))}
                        onChange={e => setYear(e?.value)}
                    />
                </Col>
                <Col xs={2} className={classNames("align-content-end")}>
                    {umpires.length ? (
                        <DownloadButton umpires={umpires} />
                    ) : (
                        <></>
                    )}
                </Col>
            </Row>
            <Row>
                <Col xs={{ span: 6, offset: 3 }}>
                    <BonusTable umpires={umpires} />
                </Col>
            </Row>
        </>
    );
};

export default Bonus;
